import React, { Component } from "react";

class LabMember extends Component {
  componentDidMount() {
    if (this.props.first) {
      this.focusedItem.focus();
    }
  }
  render() {
    return (
      <div className="row py-3">
        <div className="col-md-2 float-right">
          <img
            src={this.props.member.picture}
            alt={this.props.member.name}
            width="100%"
            height="auto"
          />
        </div>
        <div className="col-md-5 float-left">
          <u>
            <h5>{this.props.member.name}</h5>
          </u>
          <strong>
            <h6>{this.props.member.position}</h6>
          </strong>
          {this.props.member.email && (
            <h6>
              <a
                className="b-link"
                href={`mailto:${this.props.member.email}`}
                ref={(focus) => {
                  if (this.props.first) {
                    this.focusedItem = focus;
                  }
                }}
              >
                {this.props.member.email}
              </a>
            </h6>
          )}
          {this.props.member.link && (
            <h6>
              <a
                className="b-link"
                href={this.props.member.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {this.props.member.link}
              </a>
            </h6>
          )}
        </div>
      </div>
    );
  }
}

export default LabMember;
